var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgPauseButtoninline = function SvgPauseButtoninline(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 29,
    height: 38,
    viewBox: "0 0 29 38"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "PauseButton_inline_svg__a",
    d: "M55 110C24.624 110 0 85.376 0 55S24.624 0 55 0s55 24.624 55 55-24.624 55-55 55zm0-5c27.614 0 50-22.386 50-50S82.614 5 55 5 5 27.386 5 55s22.386 50 50 50z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-40 -36)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "PauseButton_inline_svg__b",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#PauseButton_inline_svg__a"
  })), /*#__PURE__*/React.createElement("use", {
    fill: "#000",
    fillOpacity: 0.4,
    xlinkHref: "#PauseButton_inline_svg__a"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    fillOpacity: 0.7,
    d: "M55 110c30.376 0 55-24.624 55-55S85.376 0 55 0v55H0c0 30.376 24.624 55 55 55z",
    mask: "url(#PauseButton_inline_svg__b)"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 .997C0 .447.457 0 .994 0h6.98a1 1 0 0 1 .994.997v36.006c0 .55-.457.997-.994.997H.994A1 1 0 0 1 0 37.003V.997zm20.032 0c0-.55.457-.997.994-.997h6.98A1 1 0 0 1 29 .997v36.006c0 .55-.457.997-.994.997h-6.98a1 1 0 0 1-.994-.997V.997z"
  }))));
};
export default SvgPauseButtoninline;